import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)
const _hoisted_3 = { class: "pt-8 max-w-8xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10 flex items-center justify-between w-full" }
const _hoisted_4 = {
  key: 0,
  class: "text-40m text-wrh-blue-600 flex items-center justify-start"
}

import { PropType } from 'vue';
import { MenuIcon } from '@heroicons/vue/outline';
import CurrentUserMenu from './CurrentUserMenu.vue';
import { NavigationLinks } from '../types/NaviagttionLinks';


export default /*#__PURE__*/_defineComponent({
  props: {
  navigation: {
    type: Array as PropType<NavigationLinks>,
    required: false,
  },
},
  emits: ['openSidebar'],
  setup(__props, { emit }) {





return (_ctx: any,_cache: any) => {
  const _component_SidebarIcon = _resolveComponent("SidebarIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("button", {
        class: "h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openSidebar')))
      }, [
        _hoisted_2,
        _createVNode(_unref(MenuIcon), {
          class: "h-6 w-6",
          "aria-hidden": "true"
        })
      ]),
      _createVNode(CurrentUserMenu, { class: "md:hidden" })
    ]),
    _createElementVNode("header", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigation, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.name,
          custom: "",
          to: item.href
        }, {
          default: _withCtx(({ isActive }) => [
            isActive
              ? (_openBlock(), _createElementBlock("h1", _hoisted_4, [
                  _createVNode(_component_SidebarIcon, {
                    name: item.icon,
                    class: "text-wrh-blue-600 mr-4 flex-shrink-0 h-10 w-10"
                  }, null, 8, ["name"]),
                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      _createVNode(CurrentUserMenu, { class: "hidden md:block" })
    ])
  ], 64))
}
}

})